import React from 'react'
import PropTypes from 'prop-types'

const propTypes = {
  children: PropTypes.node,
  html: PropTypes.string,
  keepMargin: PropTypes.bool,
}

// Add any default values for props
const defaultProps = null

function RichText({ children, keepMargin, html }) {
  const className = `rich-text${keepMargin ? '' : ' layout--clear-margin'}`
  if (html) {
    return (
      <div
        className={className}
        dangerouslySetInnerHTML={{ __html: html }}
        data-readaloud
      />
    )
  }

  return <div className={className}>{children}</div>
}

RichText.displayName = 'RichText'
RichText.propTypes = propTypes
RichText.defaultProps = defaultProps

export default RichText



// WEBPACK FOOTER //
// ./src/components/RichText/RichText.js